<template>
    <v-container>
        <v-row>
            <v-col>
                <div class="bd-form" v-html="form">
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    export default {
        name: 'PasswordReset',
        data() {
            return {
                form: '',
                loading: true,
                errorText: ''
            }
        },
        mounted() {
            let url = ''
            if( this.$route.query.hasOwnProperty('action') 
                && this.$route.query.action === 'reset'
                && this.$route.query.hasOwnProperty('prid')
                && this.$route.query.hasOwnProperty('linkid')) {

                //matrix listens for change to dispaly password reset form instead of redirect
                let changeVar = '';
                if (this.$route.query.hasOwnProperty('change')) {
                    changeVar = `&change=${this.$route.query.change}`;
                }

                url = `${this.$store.state.client_vars.PASSWORDRESET}?action=${this.$route.query.action}&prid=${this.$route.query.prid}&linkid=${this.$route.query.linkid}${changeVar}`
            } else {
                url = `${this.$store.state.client_vars.PASSWORDRESET}`
            }

            this.$axios({
                url,
                responseType: 'document'
            })
            .then(response => {
                this.form = response.data.body.innerHTML
                this.loading = false
                this.setInterval()
            })
            .then(() => {
                let js = document.querySelectorAll('form script');
                for(let i = 0; i < js.length; i++) {
                    eval(js[i].text)
                }
            })
            .catch(error => console.log('Failed to return form', error))  
        },
        methods: {
            setInterval: function() {
                // wait for form to appear before binding events to it
                let interval = window.setInterval(() => {
                    if(document.querySelector('form')) {
                        clearInterval(interval)
                        this.bindForm(this.form)
    
                    } else {
                        console.log('finding....')
                    }
                }, 1000)
            },
            bindForm: function(form) {
                document.querySelector('form').addEventListener('submit', (e) => {
                    e.preventDefault();
                    this.postForm(e.target)
                })
            },
            postForm: function(form) {
                this.form = "Loading"
                let url = form.getAttribute('action');

                this.$axios({
                    method: 'post',
                    url: url,
                    data: new FormData(event.target),
                    responseType: 'document'
                    // headers: {'Content-Type': 'multipart/form-data' },
                })
                .then((response) => {
                    this.form = response.data.body.innerHTML
                    this.setInterval()
                    this.$axios.get(`${this.$store.state.client_vars.MENU}/_nocache`)
                    .then(response => {
                        this.$store.commit('addMenu', response.data)
                    })
                    .catch(error => console.log('Failed to get menu', error))
                })
                .then(() => {
                    let js = document.querySelectorAll('form script');
                    for(let i = 0; i < js.length; i++) {
                        eval(js[i].text)
                    }
                })
                event.preventDefault();
            }
        }
    }
</script>

<style lang="scss">
  .bd-password-reset-form {
      max-width: 800px;
      margin: auto;

      input[type=password] {
          margin-bottom: 4px;
      }
  }

  .bd-submit-button-wrapper {
      overflow: hidden;
  }
</style>